const javascriptInstructions = (account, coreEventName) => {
  const re = `const Pmf = require('pmf-engine-sdk');
const pmf = new Pmf('${account.id}');

// userId is an identifier of your user. It can be email, id, 
// or anything else that will be the same string that identifies user.
pmf.identify(userId);

await pmf.event('${coreEventName}');
  `

  const gc = `const Pmf = require('pmf-engine-sdk');
const pmf = new Pmf('${account.id}');
pmf.identify(userId);

const command = await pmf.getCommand({ eventName: '${coreEventName}' })

if(command && command.type === 'form') {
  // show form to the user
  window.location = command.url
}
  `

  return { re, gc }
}

export default javascriptInstructions
